export default "__VITE_ASSET__BY4MNJ6h__"